import { render, staticRenderFns } from "./ScrollableContent.vue?vue&type=template&id=2c327bd2&scoped=true"
import script from "./ScrollableContent.vue?vue&type=script&lang=js"
export * from "./ScrollableContent.vue?vue&type=script&lang=js"
import style0 from "./ScrollableContent.vue?vue&type=style&index=0&id=2c327bd2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c327bd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c327bd2')) {
      api.createRecord('2c327bd2', component.options)
    } else {
      api.reload('2c327bd2', component.options)
    }
    module.hot.accept("./ScrollableContent.vue?vue&type=template&id=2c327bd2&scoped=true", function () {
      api.rerender('2c327bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScrollableContent.vue"
export default component.exports